    <p-toast></p-toast>
    <app-page-shell>
      <app-page-hero eyebrow="HR Documents" title="Document Compliance Center" subtitle="Track employee document readiness, expiry pressure, verification work, and logistics blockers.">
        <div actions>
          <button pButton type="button" label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true" (click)="load()"></button>
        </div>
      </app-page-hero>

      @if (loading) {
        <p-progressBar mode="indeterminate"></p-progressBar>
      }

      <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

      <app-page-data-panel title="Filters" subtitle="Narrow document readiness by status and logistics worker category." [resultText]="rows.length + ' rows'">
        <div class="filter-grid">
          <p-inputGroup>
            <p-inputGroupAddon><i class="fa-solid fa-signal"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="statusFilter" [options]="statusOptions" optionLabel="label" optionValue="value" [(ngModel)]="status" [showClear]="true" styleClass="w-full" (onChange)="load()"></p-select>
              <label for="statusFilter">Compliance status</label>
            </p-iftaLabel>
          </p-inputGroup>

          <p-inputGroup>
            <p-inputGroupAddon><i class="fa-solid fa-user-gear"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="workerFilter" [options]="workerCategoryOptions" optionLabel="label" optionValue="value" [(ngModel)]="workerCategory" [showClear]="true" styleClass="w-full" (onChange)="load()"></p-select>
              <label for="workerFilter">Worker category</label>
            </p-iftaLabel>
          </p-inputGroup>

          <button pButton type="button" label="Clear" icon="pi pi-filter-slash" severity="secondary" [outlined]="true" (click)="clearFilters()"></button>
        </div>
      </app-page-data-panel>

      <app-page-data-panel title="Readiness Rows" subtitle="Rows include uploaded documents and missing required documents generated by the compliance evaluator." [resultText]="(center.summary?.evaluatedAt | date:'medium') || 'Not evaluated'">
        @if (canManageDocuments) {
          <div actions><button pButton type="button" label="Evaluate Compliance" icon="fa-solid fa-shield-halved" (click)="evaluate()" [disabled]="loading"></button></div>
        }
        <p-table [value]="rows" [loading]="loading" styleClass="p-datatable-sm" responsiveLayout="scroll" [tableStyle]="{ 'min-width': '1120px' }" [paginator]="true" [rows]="20" [rowsPerPageOptions]="[20, 50, 100]">
          <ng-template pTemplate="header">
            <tr>
              <th>Employee</th>
              <th>Worker</th>
              <th>Document</th>
              <th>Status</th>
              <th>Verification</th>
              <th>Expiry</th>
              <th>Blocks</th>
              <th>Source</th>
              <th style="width: 5rem">Open</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td><strong>{{ row.employeeName || '-' }}</strong><br><small>{{ row.employeeNumber || row.employeeId }}</small></td>
              <td><p-tag [value]="format(row.workerCategory)" severity="info"></p-tag></td>
              <td><strong>{{ row.documentName || '-' }}</strong><br><small>{{ row.documentCode || '-' }}</small></td>
              <td><p-tag [value]="format(row.expiryStatus)" [severity]="statusSeverity(row.expiryStatus)"></p-tag></td>
              <td>{{ format(row.verificationStatus) }}</td>
              <td>{{ row.expiryDate || '-' }}<br><small>{{ daysLabel(row) }}</small></td>
              <td>
                <div class="block-list">
                  @if (row.blocksDispatch) { <span>Dispatch</span> }
                  @if (row.blocksMobilization) { <span>Mobilization</span> }
                  @if (row.blocksPayroll) { <span>Payroll</span> }
                  @if (row.blocksOnboardingCompletion) { <span>Onboarding</span> }
                  @if (!row.blocksDispatch && !row.blocksMobilization && !row.blocksPayroll && !row.blocksOnboardingCompletion) { <small>-</small> }
                </div>
              </td>
              <td>{{ format(row.sourceModule) }}</td>
              <td>
                <button pButton type="button" icon="pi pi-arrow-right" [rounded]="true" [text]="true" [routerLink]="['/hr/employees', row.employeeId]"></button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="9">No HR document compliance rows found.</td></tr>
          </ng-template>
        </p-table>
      </app-page-data-panel>
    </app-page-shell>
